export default "__VITE_ASSET__lsim1i$W__"